<div class="col-12 align-items-center d-flex">
  <!-- <div *ngIf="isShowlable" class="col-4 f-14 font-semibold text-gray-color text-nowrap mb-0">
      Branch<span class="text-color-danger">*</span>
  </div>
   -->
  <div class="col position-relative"> 

    <ng-multiselect-dropdown class="custom_dropdown" 
    [placeholder]="placeholder" 
    [id]="id" 
    [name]="id"
    [required]="isRequired" 
    [settings]="dropdownSettings"
    [data]="data" 
    [(ngModel)]="branchIds" 
    (onSelect)="onItemSelect($event)"
    (onSelectAll)="onSelectAll($event)" 
    (onDeSelect)="onItemDeSelect($event)"
    (onDeSelectAll)="onItemDeSelectAll($event)">
    </ng-multiselect-dropdown>
 
  </div>
  
  

</div>


